import Modal from './Modal';
import TechBadge from './TechBadge';

export default function ProjectDetailModal({ project, onClose }) {
  return (
    <Modal isOpen={!!project} onClose={onClose} title={project?.title}>
      {project && (
        <article className="project-modal">
          <div className="project-modal__media">
            {project.image ? (
              <img src={project.image} alt="" className="project-modal__image" />
            ) : (
              <div className="project-modal__fallback" aria-hidden="true">
                {project.title.charAt(0)}
              </div>
            )}
          </div>
          <div className="project-modal__content">
            <div className="project-modal__header">
              <h3 className="project-modal__title">{project.title}</h3>
              {project.year && <span className="project-modal__year">{project.year}</span>}
            </div>
            {project.description && (
              <p className="project-modal__desc">{project.description}</p>
            )}
            {project.tech?.length > 0 && (
              <ul className="project-modal__tags" aria-label="Technologies used">
                {project.tech.map((tech) => (
                  <TechBadge key={tech} name={tech} />
                ))}
              </ul>
            )}
            {project.url && (
              <a
                className="btn btn--primary project-modal__link"
                href={project.url}
                target="_blank"
                rel="noreferrer"
              >
                View project →
              </a>
            )}
          </div>
        </article>
      )}
    </Modal>
  );
}
